import { Box, Heading } from 'grommet'
import styled, { css } from 'styled-components'

import { NormalizedWrapper } from '@theme'

export const Wrapper = styled(NormalizedWrapper)`
  position: relative;

  ${({ theme }) => css`
    ${theme.below.laptop`
      padding: 0 ${theme.newSpaces.sm}px;
    `}

    ${theme.below.mobileXL`
      padding: 0 ${theme.newSpaces.xl}px;
      margin-top: 0;
    `}
  `}
`

export const Cards = styled(Box)`
  max-width: 100%;
`

export const TitleProcess = styled(Heading)`
  ${({ theme }) => css`
    ${theme.getTypography('desktop', 'title', 'title2')}

    color: ${theme.newColors.darkGray};

    ${theme.below.mobileXL`
      ${theme.getTypography('mobile', 'title', 'title3')}
    `}
  `}
`

export const TextWrapper = styled(Box)`
  ${({ theme }) => css`
    ${theme.below.laptop`
      max-width: 100%;
    `}
  `}
`
